import { Maybe, Optional } from '@vimeo/core/types/generic';

import { liveTrackingConfig } from '../configs/LiveTrackingConfig';
import { createLiveSchemaEventFactoryNew, TSchemaEventFactoryNew } from './helpers/utils';

/**
 * Engagement polls tracking.
 *
 * @link https://big-picture.vimeows.com/events/details/vimeo.live_engagement_polls
 */
const trackEngagementPolls: TSchemaEventFactoryNew = createLiveSchemaEventFactoryNew(
  'vimeo.live_engagement_polls',
  4,
  () => ({
    ...liveTrackingConfig.BIG_PICTURE_INTERACTION_SCHEMA_BASE,
    isInProgram: null,
    countOptions: null,
  }),
);

export function trackViewPoll(): void {
  return trackEngagementPolls({ eventName: 'view_poll', eventType: 'impression' });
}

export function trackClickAddPoll(): void {
  return trackEngagementPolls({ eventName: 'click_add_poll' });
}

export function trackOpenPollsTab(): void {
  return trackEngagementPolls({ eventName: 'open_polls_tab' });
}

export function trackSavePoll(countOptions: Optional<number>): void {
  return trackEngagementPolls({ eventName: 'save_poll', countOptions });
}

export function trackCancelPollCreation(): void {
  return trackEngagementPolls({ eventName: 'cancel_poll_creation' });
}

export function trackClickEditPoll(): void {
  return trackEngagementPolls({ eventName: 'click_edit_poll' });
}

export function trackRemovePollFromEvent(): void {
  return trackEngagementPolls({ eventName: 'remove_poll_from_event' });
}

export function trackOpenPoll(): void {
  return trackEngagementPolls({ eventName: 'open_poll' });
}

export function trackPublishPollResults(): void {
  return trackEngagementPolls({ eventName: 'publish_poll_results' });
}

export function trackArchivePoll(): void {
  return trackEngagementPolls({ eventName: 'archive_poll' });
}

export function trackVoteInPoll(): void {
  return trackEngagementPolls({ eventName: 'vote_in_poll' });
}

export function trackHidePollInScene(location: string): void {
  return trackEngagementPolls({ eventName: 'hide_poll_in_scene', location });
}

export function trackShowPollResultsInScene(isInProgram: boolean, location: string): void {
  return trackEngagementPolls({ eventName: 'show_poll_results_in_scene', isInProgram, location });
}

export function trackShowPollQuestionInScene(isInProgram: boolean, location: string): void {
  return trackEngagementPolls({ eventName: 'show_poll_question_in_scene', isInProgram, location });
}

export function trackRemovePollFromScene(): void {
  return trackEngagementPolls({ eventName: 'remove_poll_from_scene' });
}

export function trackAddPollToScene(location: Maybe<string> = null): void {
  return trackEngagementPolls({ eventName: 'add_poll_to_scene', location });
}
